import { render } from "./PopHeader.vue?vue&type=template&id=f6ba2f34&scoped=true"
import script from "./PopHeader.vue?vue&type=script&lang=js"
export * from "./PopHeader.vue?vue&type=script&lang=js"

import "./PopHeader.vue?vue&type=style&index=0&id=f6ba2f34&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ba2f34"]])

export default __exports__